import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import { Text, ProgressCircle } from "@react-spectrum/s2";
interface StatCardProps {
    label: string;
    value: string | number;
    loading?: boolean;
}
const StatCard: React.FC<StatCardProps> = ({ label, value, loading })=>{
    const { t } = useTranslation();
    return (<div className={" sd171 _ta171 Ue171 qe171 Tf171 Qf171 Sf171 Rf171"} style={{
        backgroundColor: 'var(--spectrum-global-color-gray-50)',
        border: '1px solid var(--spectrum-global-color-gray-200)',
        borderRadius: 'var(--spectrum-alias-border-radius-regular)'
    }}>
    <Text UNSAFE_className="cc-stat-label">{label}</Text>
    {loading ? (<ProgressCircle aria-label={t('commandCenter.orgStats.loading')} size="S" isIndeterminate/>) : (<Text UNSAFE_className="cc-stat-value">
        {typeof value === 'number' ? value.toLocaleString() : value}
      </Text>)}
  </div>);
};
interface OrgStats {
    totalOrgs: number;
    activeSites: number;
    totalRequestVolume: string;
    totalIndexedDocuments: string;
}
interface OrgStatsCardsProps {
    stats: OrgStats;
    loading?: boolean;
}
const STAT_CARDS = (t: TFunction): {
    key: keyof OrgStats;
    label: string;
}[] =>[
        {
            key: 'totalOrgs',
            label: t('commandCenter.orgStats.cards.totalOrgs')
        },
        {
            key: 'activeSites',
            label: t('commandCenter.orgStats.cards.activeSites')
        },
        {
            key: 'totalRequestVolume',
            label: t('commandCenter.orgStats.cards.totalRequestVolume')
        },
        {
            key: 'totalIndexedDocuments',
            label: t('commandCenter.orgStats.cards.totalIndexedDocuments')
        }
    ];
export const OrgStatsCards: React.FC<OrgStatsCardsProps> = ({ stats, loading })=>{
    const { t } = useTranslation();
    const cards = React.useMemo(()=>STAT_CARDS(t), [
        t
    ]);
    return (<div className="cc-stats-grid">
    {cards.map(({ key, label })=>(<StatCard key={key} label={label} value={stats[key]} loading={loading}/>))}
  </div>);
};
export default OrgStatsCards;

import "macro-c38dd12087c10cc91894cb133fe66d2831aed294c9be1b1ce36e2e42a6d631a9.css";